import { render, staticRenderFns } from "./m-create-contact-status.vue?vue&type=template&id=aa07a78c&lang=pug"
import script from "./m-create-contact-status.vue?vue&type=script&lang=js"
export * from "./m-create-contact-status.vue?vue&type=script&lang=js"
import style0 from "./m-create-contact-status.vue?vue&type=style&index=0&id=aa07a78c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports